import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const STORAGE_KEY = 'shippingNoticePopup_dismissed';

const ShippingNoticePopup = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 한국 시간 2025년 8월 7일 이후에는 팝업을 표시하지 않음
    const now = new Date();
    const koreaTime = new Date(now.getTime() + 9 * 60 * 60 * 1000); // UTC+9 한국 시간
    const hideAfterDate = new Date('2025-08-07T00:00:00+09:00'); // 한국 시간 8월 7일 00:00

    if (koreaTime >= hideAfterDate) {
      return; // 8월 7일 이후에는 팝업을 표시하지 않음
    }

    // localStorage에서 팝업 닫힘 여부 확인
    const isDismissed = localStorage.getItem(STORAGE_KEY);
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // localStorage에 팝업 닫힘 상태 저장
    localStorage.setItem(STORAGE_KEY, 'true');
    if (onClose) {
      onClose();
    }
  };

  const handleOverlayClick = (e) => {
    // 오버레이 클릭 시 팝업 닫기
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  return (
    <PopupOverlay onClick={handleOverlayClick}>
      <PopupContainer>
        <PopupHeader>
          <NoticeTitle>배송 안내</NoticeTitle>
          <CloseButton onClick={handleClose}>✕</CloseButton>
        </PopupHeader>
        <PopupContent>
          <NoticeText>
            물량 이슈로 인해 <strong>2025-08-04 (월)</strong> 발송 예정 상품은
            <br />
            <strong>2025-08-06 (수)</strong> 부터 순차적으로 발송될 예정입니다.
            <br />
            <br />
            이용에 불편 드려 죄송합니다.
          </NoticeText>
        </PopupContent>
        <PopupFooter>
          <ConfirmButton onClick={handleClose}>확인</ConfirmButton>
        </PopupFooter>
      </PopupContainer>
    </PopupOverlay>
  );
};

// Styled Components
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

const PopupContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  min-width: 320px;
  max-width: 400px;
  margin: 20px;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 0 20px;
`;

const NoticeTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
  }
`;

const PopupContent = styled.div`
  padding: 20px;
`;

const NoticeText = styled.p`
  margin: 0;
  line-height: 1.6;
  color: #555;
  font-size: 14px;
  text-align: center;

  strong {
    color: #e74c3c;
    font-weight: 600;
  }
`;

const PopupFooter = styled.div`
  padding: 0 20px 20px 20px;
  display: flex;
  justify-content: center;
`;

const ConfirmButton = styled.button`
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2980b9;
  }

  &:active {
    background-color: #21618c;
  }
`;

export default ShippingNoticePopup;
